export default __webpack_public_path__ + "static/media/susa.02d31ffc.svg";